import { NgModule } from '@angular/core';
import { AlertSuppressionRoutingModule } from './alert-suppression-routing.module';

@NgModule({
  imports: [
    AlertSuppressionRoutingModule
  ]
})
export class AlertSuppressionModule { }

